import cookieManager from "../../../../utils/cookieManager";
import axios from "axios";
import JournalActions from "../../../../reducers/modules/accounting/journal/actions";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { Navigate } from "react-router-dom";

const MySwal = withReactContent(Swal);
const url = process.env.REST_URL + "accounting/journal";

export default class JournalMiddleware {
  static create() {
    return (dispatch) => {
      dispatch(JournalActions.create());
    };
  }

  static update(params) {
    return (dispatch) => {
      dispatch(JournalActions.update());
      JournalMiddleware.showOne(dispatch, params);
    };
  }

  static detail(params) {
    return (dispatch) => {
      dispatch(JournalActions.beforeDetail());
      JournalMiddleware.showOne(dispatch, params);
    };
  }

  static detailData(params) {
    return (dispatch) => {
      dispatch(JournalActions.beforeDetail());
      JournalMiddleware.getDetailData(dispatch, params);
    };
  }

  static detail(params) {
    return (dispatch) => {
      dispatch(JournalActions.beforeDetail());
      JournalMiddleware.getDetail(dispatch, params);
    };
  }

  static list(params) {
    return (dispatch) => {
      dispatch(JournalActions.process());
      JournalMiddleware.showlist(dispatch, params);
    };
  }
  static reset() {
    return (dispatch) => {
      dispatch(JournalActions.reset());
    };
  }
  static resetList() {
    return (dispatch) => {
      dispatch(JournalActions.resetList());
    };
  }
  static getOne(params) {
    return (dispatch) => {
      dispatch(JournalActions.view());
      JournalMiddleware.showOne(dispatch, params);
    };
  }

  static beforeSaveNew(post, search) {
    return (dispatch) => {
      dispatch(JournalActions.submit());
      JournalMiddleware.saveNew(dispatch, post, search);
    };
  }
  static beforeSaveUpdate(params, post, search) {
    return (dispatch) => {
      dispatch(JournalActions.submit());
      JournalMiddleware.saveUpdate(dispatch, params, post, search);
    };
  }

  static getPrint(params) {
    return (dispatch) => {
      dispatch(JournalActions.beforePrint());
      JournalMiddleware.showPrint(dispatch, params);
    };
  }

  static beforeChangeStatus(params, post) {
    return (dispatch) => {
      dispatch(JournalActions.submit());
      JournalMiddleware.saveChangeStatus(dispatch, params, post);
    };
  }

  static beforeCancel(id, params) {
    return (dispatch) => {
      dispatch(JournalActions.cancel());
      JournalMiddleware.cancel(dispatch, params, id);
    };
  }

  static getHelper(params = null) {
    return (dispatch) => {
      JournalMiddleware.showHelper(dispatch, params);
    };
  }

  static getHelperFull() {
    return (dispatch) => {
      JournalMiddleware.showHelperFull(dispatch);
    };
  }

  static getToken() {
    return cookieManager.getUserToken();
  }

  static showlist(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${JournalMiddleware.getToken()}`,
      },
      url: url,
      responseType: "json",
      params: params,
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(JournalActions.list(response.data.result));
        }
      })
      .catch((error) => {
        JournalMiddleware.alertHendler(dispatch, error);
      });
  }
  static showHelperFull(dispatch) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${JournalMiddleware.getToken()}`,
      },
      url: process.env.REST_URL + "helper/get-helper-journal",
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(JournalActions.helperFull(response.data.result));
        }
      })
      .catch((error) => {
        JournalMiddleware.alertHendler(dispatch, error);
      });
  }
  static showHelper(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${JournalMiddleware.getToken()}`,
      },
      url: process.env.REST_URL + "helper/get-helper-journal",
      responseType: "json",
      params: params,
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(JournalActions.helper(response.data.result));
        }
      })
      .catch((error) => {
        JournalMiddleware.alertHendler(dispatch, error);
      });
  }
  static showOne(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${JournalMiddleware.getToken()}`,
      },
      url: url + "/" + params,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(JournalActions.view(response.data.result));
        }
      })
      .catch((error) => {
        JournalMiddleware.alertHendler(dispatch, error);
      });
  }

  static getDetail(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${JournalMiddleware.getToken()}`,
      },
      url: url + "/detail/" + params,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(JournalActions.afterData(response.data.result));
        }
      })
      .catch((error) => {
        JournalMiddleware.alertHendler(dispatch, error);
      });
  }

  static showPrint(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${JournalMiddleware.getToken()}`,
      },
      url: url + "/print/" + params,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(JournalActions.print(response.data.result));
        }
      })
      .catch((error) => {
        JournalMiddleware.alertHendler(dispatch, error);
      });
  }

  static getDetailData(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${JournalMiddleware.getToken()}`,
      },
      url: process.env.REST_URL + "accounting/journal-detail/" + params,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(JournalActions.afterDetail(response.data.result));
        }
      })
      .catch((error) => {
        JournalMiddleware.alertHendler(dispatch, error);
      });
  }

  static cancel(dispatch, params, id) {
    axios({
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${JournalMiddleware.getToken()}`,
      },
      url: url + "/cancel/" + id,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(
            JournalActions.process(),
            JournalMiddleware.getDetailData(dispatch, params)
          );
          JournalMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Cancel Data Successfully",
            "success"
          );
        }
      })
      .catch((error) => {
        JournalMiddleware.alertHendler(dispatch, error, true);
      });
  }

  static saveNew(dispatch, post, search) {
    axios({
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${JournalMiddleware.getToken()}`,
      },
      url: url,
      data: post,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(
            JournalActions.process(),
            JournalMiddleware.showlist(dispatch, search)
          );
          dispatch(JournalActions.success());
          JournalMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Create Data Successfully",
            "success"
          );
        }
      })
      .catch((error) => {
        JournalMiddleware.alertHendler(dispatch, error);
      });
  }

  static saveUpdate(dispatch, params, post, search) {
    axios({
      method: "PUT",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: `Bearer ${JournalMiddleware.getToken()}`,
      },
      url: url + "/" + params,
      data: post,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(
            JournalActions.process(),
            JournalMiddleware.getDetailData(dispatch, params)
          );
          dispatch(JournalActions.success());
          JournalMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Update Data Successfully",
            "success"
          );
        }
      })
      .catch((error) => {
        JournalMiddleware.alertHendler(dispatch, error);
      });
  }

  static saveChangeStatus(dispatch, params, post) {
    axios({
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${JournalMiddleware.getToken()}`,
      },
      url: url + "/change/" + params,
      data: post,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(
            JournalActions.process(),
            JournalMiddleware.showList(dispatch, search)
          );
          dispatch(JournalActions.success());
          JournalMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Update Data Successfully",
            "success"
          );
        }
      })
      .catch((error) => {
        JournalMiddleware.alertHendler(dispatch, error);
      });
  }

  static alertHendler(
    dispatch,
    result,
    isSwal = false,
    extraMessage = "",
    type = "error"
  ) {
    if (type == "error") {
      if (result.response) {
        const status = result.response.status;
        switch (status) {
          case 500:
            if (isSwal) {
              const data = result.response.data;
              MySwal.hideLoading();
              MySwal.update({
                title: "Delete Error",
                html: data.error,
                icon: "error",
                showConfirmButton: true,
              });
            } else {
              const data = result.response.data;
              dispatch(JournalActions.error(data.error));
            }
            break;
          case 403:
            console.log("Error 403");
            break;
          case 404:
            console.log("Error 404");
            break;
          case 401:
            const data = result.response.data;
            MySwal.fire({
              title: "Login Invalid",
              html: data.error,
              icon: "error",
              showConfirmButton: true,
            }).then((result) => {
              if (result.isConfirmed) {
                <Navigate to="/login"></Navigate>;
              }
            });
            break;
        }
      } else if (result.request) {
        MySwal.fire({
          title: "Internal Server Error",
          html: "Please info your Developer to fix this",
          icon: "error",
          showConfirmButton: true,
        });
        dispatch(JournalActions.reset());
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log("Error", result.message);
      }
    } else {
      MySwal.fire({
        title: "Success",
        html: extraMessage,
        icon: "success",
        showConfirmButton: true,
      });
    }
  }
}
